import { render, staticRenderFns } from "./fast-login.vue?vue&type=template&id=66d37c9c&"
import script from "./fast-login.vue?vue&type=script&lang=ts&"
export * from "./fast-login.vue?vue&type=script&lang=ts&"
import style0 from "./fast-login.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports